import React, { useEffect, useState } from 'react'
import { ClockCircleOutlined } from '@ant-design/icons'
import { Button, message } from 'antd'
import swal from 'utils/swal'
import LoginRepository from 'ecp/repositories/LoginRepository'
import { swalError } from 'components/SwalError/SwalError'

type Props = {
  email: string
}

export default function SignupFormResendToken ({ email } : Props) {
  const [secondsTime, setSecondsTime] = useState<number | undefined>(0)
  const [sent, setSent] = useState<Boolean>(false)
  const [time, setTime] = useState<string>('')
  const [loading, setLoading] = useState(false)

  const resendToken = async (email : string) => {
    setLoading(true)

    try {
      const response = await LoginRepository.reset(email)

      setSecondsTime(undefined)
      setSecondsTime(15)

      setSent(true)

      if (response.data.message) swal.basic({ title: 'Sucesso!', text: response.data.message, icon: 'success' })
    } catch (err) {
      swalError({ title: 'Atenção', icon: 'warning', err })
    }
    setLoading(false)
  }

  useEffect(() => {
    if (secondsTime) {
      let time = secondsTime || 0
      const interval = setInterval(() => {
        time--
        if (time < 1) {
          setSent(false)
          clearInterval(interval)
        }
        setTime(time.toString())
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [secondsTime])

  if (sent) {
    return (
      <p className='text-center mt-2 forgot-password-onidata__sent-token' ><ClockCircleOutlined /> Reenviar token em { time }s</p>
    )
  }

  return (
    <>
      <Button
        loading={loading}
        type='link'
        onClick={() => {
          if (email) resendToken(email)
          else message.error('Email não encontrado')
        }}
      >
        Reenviar token
      </Button>
    </>
  )
}
